// extracted by mini-css-extract-plugin
export var work = "style-module--work--2AhX3";
export var job = "style-module--job--3kb2V";
export var logoContainer = "style-module--logoContainer--29G5r";
export var rbc = "style-module--rbc--gFT9C";
export var ministry = "style-module--ministry--3YSBq";